import { locationIdFormat } from "@redotech/redo-inventory-id";
import { suppliesInventoryConfigIdFormat } from "@redotech/redo-marketplace-id";
import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const createSuppliesInventoryConfig = {
  name: "createSuppliesInventoryConfig" as const,
  input: z.object({
    suppliesProductId: productIdFormat.schema,
    locationId: locationIdFormat.schema,
    onHandInventory: z.number().int().min(0),
    inventoryReorderThreshold: z.number().int().min(0),
    suppliesReorderQuantity: z.number().int().min(1),
    // Empty for label paper; one or more tied OMS parcel oids for parcel packaging.
    tiedParcelOids: z.array(z.string()),
  }),
  output: z.object({
    suppliesInventoryConfigId: suppliesInventoryConfigIdFormat.schema,
  }),
};
